import {
  SHOW_LOADING,
  HIDE_LOADING,
  SHOW_ERROR,
  UPDATE_DASHBOARD_STATS,
  FETCH_DASHBOARD_STATS_START,
  FETCH_DASHBOARD_STATS_ERROR
} from "./Types";
import api from "../../api";

export function getDashboardStats(year = "YTD", { showLoading = false } = {}) {
  return async function (dispatch) {
    if (showLoading) dispatch({ type: SHOW_LOADING });
    dispatch({ type: FETCH_DASHBOARD_STATS_START, year });

    try {
      const result = await api.stats.getDashboardStats(year);

      if (result.success) {
        const { availableYears, ...stats } = result.data || {};
        dispatch({
          type: UPDATE_DASHBOARD_STATS,
          year,
          data: stats,
          availableYears
        });
      } else {
        dispatch({ type: FETCH_DASHBOARD_STATS_ERROR, year });
        const message = typeof result.error === "string"
          ? result.error
          : (result.error?.message || `Failed to load dashboard (${result.code || "unknown"})`);
        dispatch({ type: SHOW_ERROR, message });
      }
    } catch (e) {
      console.error(e);
      dispatch({ type: FETCH_DASHBOARD_STATS_ERROR, year });
    } finally {
      if (showLoading) dispatch({ type: HIDE_LOADING });
    }
  };
}
